import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  GlassHeroContainer,
} from '../../components/glassmorphism/GlassmorphismStyles';

const ContactUsPage: React.FC = () => {
  return (
    <GlassHeroContainer sx={{ minHeight: 'calc(100vh - 200px)' }}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 12, sm: 14 },
          pb: { xs: 4, sm: 6 },
          minHeight: 'calc(100vh - 300px)',
        }}
      >
        <ContactUsContainer>
          {/* Heading Section */}
          <HeadingSection>
            <HeadingWrapper>
              <Heading>Contacts</Heading>
            </HeadingWrapper>
          </HeadingSection>

          {/* Content Section */}
          <ContentSection>
            <SectionTitleWrapper>
              <SectionTitle>WORD OF MOUTH LTD</SectionTitle>
            </SectionTitleWrapper>
            <ContentWrapper>
              <BodyText>
                Registration number: <strong>16267512</strong>
                <br />
                Registered office: <strong>Cambridge House, Highgate, Forest Row, RH18 5BA, United Kingdom</strong>
                <br />
                Email: <EmailLink href="mailto:support@womapp.uk">support@womapp.uk</EmailLink>
              </BodyText>
            </ContentWrapper>
          </ContentSection>
        </ContactUsContainer>
      </Container>
    </GlassHeroContainer>
  );
};

// Main container - Frame 8
const ContactUsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '0px',
  gap: '24px',
  width: '100%',
  maxWidth: '1150px',

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    padding: '0 20px',
  },
}));

// Frame 4 - Heading Section
const HeadingSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0px',
  gap: '48px',
  width: '100%',
  maxWidth: '1150px',

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

// Frame 5 - Heading Wrapper
const HeadingWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0px',
  gap: '16px',
  width: '100%',
  maxWidth: '760px',

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

// Contacts Heading
const Heading = styled(Typography)(({ theme }) => ({
  width: '100%',
  maxWidth: '760px',
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '60px',
  lineHeight: '120%',
  textAlign: 'center',
  letterSpacing: '-0.5px',
  color: theme.palette.mode === 'dark' ? '#00FFFF' : '#005CAD',

  [theme.breakpoints.down('md')]: {
    fontSize: '48px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '36px',
  },
}));

// Frame 5 - Content Section
const ContentSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0px',
  gap: '8px',
  width: '100%',
  maxWidth: '1150px',

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

// Frame 5 - Section Title Wrapper
const SectionTitleWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0px',
  gap: '16px',
  width: '100%',
  maxWidth: '760px',

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

// Section Title - WORD OF MOUTH LTD
const SectionTitle = styled(Typography)(({ theme }) => ({
  width: '100%',
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 800,
  fontSize: '20px',
  lineHeight: '160%',
  letterSpacing: '0.15px',
  color: theme.palette.mode === 'dark' ? '#00FFFF' : '#005CAD',
  textAlign: 'left',
}));

// Frame 6 - Content Wrapper
const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0px',
  gap: '16px',
  width: '100%',
  maxWidth: '760px',

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

// Body Text
const BodyText = styled(Typography)(({ theme }) => ({
  width: '100%',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '150%',
  letterSpacing: '0.15px',
  color: theme.palette.mode === 'dark' ? '#B6B6B6' : '#1A1A1A',
  textAlign: 'left',

  '& strong': {
    fontWeight: 700,
  },
}));

// Email Link
const EmailLink = styled('a')(({ theme }) => ({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '150%',
  letterSpacing: '0.15px',
  color: theme.palette.mode === 'dark' ? '#00FFFF' : '#005CAD',
  textDecoration: 'underline',
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.8,
  },
}));

export default ContactUsPage;
